<template>
  <v-dialog
    v-if="request"
    :value="value"
    width="80vw"
    max-width="1200px"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>
        <span class="headline">申請詳細情報</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-layout column mb-4>
            <v-flex class="label">申請種別</v-flex>
            <v-flex class="value"><Type :type="request.requestType"/></v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">広告主名</v-flex>
            <v-flex class="value">{{ request.advertiserName }}</v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">案件名</v-flex>
            <v-flex class="value">{{ request.insertionOrderName }}</v-flex>
          </v-layout>
          <template v-if="request.IOBudget">
            <v-layout column mb-4>
              <v-flex class="label">期間・予算</v-flex>
              <v-flex class="value">
                <v-layout class="label">
                  申請内容
                </v-layout>
                <v-layout>
                  <v-flex sm6>
                    <AppPeriod
                      :start="request.startTime"
                      :end="request.endTime"
                    />
                  </v-flex>
                  <v-flex sm2 class="text-xs-right">
                    <AppCurrency :value="request.budget" /><br />
                    <NetBudget :value="request.netBudget" />
                  </v-flex>
                </v-layout>
                <v-layout class="label">
                  現在の設定
                </v-layout>
                <v-layout>
                  <v-flex sm6>
                    <AppPeriod
                      :start="request.IOBudget.startTime"
                      :end="request.IOBudget.endTime"
                    />
                  </v-flex>
                  <v-flex sm2 class="text-xs-right">
                    <AppCurrency :value="request.IOBudget.budget" /><br />
                    <NetBudget :value="request.IOBudget.netBudget" />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <HistoryTable :items="request.IOBudget.requests" />
          </template>
          <template v-if="!request.IOBudget">
            <v-layout column mb-4>
              <v-flex class="label">期間・予算</v-flex>
              <v-flex class="value">
                <v-layout>
                  <v-flex sm6>
                    <AppPeriod
                      :start="request.startTime"
                      :end="request.endTime"
                    />
                  </v-flex>
                  <v-flex sm2 class="text-xs-right">
                    <AppCurrency :value="request.budget" /><br />
                    <NetBudget :value="request.netBudget" />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout column mb-4>
              <v-flex class="label">申請者情報</v-flex>
              <v-flex class="value">
                <v-layout align-center ma-2>
                  <v-flex class="label" xs3>所属：</v-flex>
                  <v-flex class="value">{{
                    request.requestAccountBelongsTo
                  }}</v-flex>
                </v-layout>
                <v-layout align-center ma-2>
                  <v-flex class="label" xs3>申請者：</v-flex>
                  <v-flex class="value">{{
                    request.requestAccountName
                  }}</v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout column mb-4>
              <v-flex class="label">申請日時</v-flex>
              <v-flex class="value"
                ><AppDateTime :value="request.requestTime"
              /></v-flex>
            </v-layout>
            <v-layout v-if="request.isRejected" column mb-4>
              <v-flex class="label">却下理由</v-flex>
              <v-flex class="value">
                <p>{{ request.reason }}</p>
              </v-flex>
            </v-layout>
          </template>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('input', false)">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NetBudget from './NetBudget.vue'
import Type from '@/components/Shared/Presentation/Request/Type'
import HistoryTable from './HistoryTable'

export default {
  name: 'DetailModal',
  components: { Type, HistoryTable, NetBudget },
  props: {
    value: Boolean,
    request: Object,
  },
  watch: {
    request(request) {
      if (request) {
        request.fetchIOBudget()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.value {
  font-size: 16px;
}
</style>
